import { IonModal, IonCheckbox } from "@ionic/react";

import PDFLogo from "../../../assets/images/pdf.webp";

import "./attesa.style.css";
import { getNameFromUrl } from "../../../lib/utils/common.utils";

interface FileLinkModalProps {
  visible: boolean;
  dismiss: () => any;
  files: any[];
  fileFields: any[];
  setFileFields: () => any;
  deleteFile: (id: string) => any;
  updateFileLinkedField: (
    filePath: string,
    fieldId: string,
    checked: boolean
  ) => any;
  detailed?: boolean;
}

const AttesaFileLink = (props: FileLinkModalProps) => {
  // Checking if checkbox should be disabled
  const shouldBeDisabled = (id: string, filePath: string) => {
    const existingFile = props.files.find((file) => file.linkedField === id);
    if (existingFile && existingFile.path !== filePath) return true;

    const originalFile = props.files.find((file) => file.path === filePath);
    if (originalFile?.isOutput) return true;

    return false;
  };

  // Checking if checked is checked
  const isChecked = (id: string, filePath: string) => {
    return props.files.find(
      (file: any) =>
        file.path !== undefined &&
        file.path === filePath &&
        file.linkedField === id
    );
  };

  const canFileBeRemoved = (file: any) => {
    return !file.isOutput;
  };

  const closeIt = () => {
    props.dismiss();
  };

  return (
    <IonModal
      isOpen={props.visible}
      swipeToClose={true}
      backdropDismiss={false}
      onDidDismiss={props.dismiss}
    >
      <div className="attesa-modal-files">
        <div>
          <p className="attesa-modal-title">Lista dei file caricati</p>

          <div style={{ borderTop: "1px solid gray" }} />

          {props.fileFields?.filter(
            (field: any) => field.ioType === "input" && !field.isHidden
          ).length > 0 && (
            <div className="filelink-category-io">
              {props.detailed && (
                <p className="filelink-category-io-title">
                  Documenti richiesti
                </p>
              )}
              {props.files
                ?.filter((file: any) => file.imageUrl)
                ?.filter((file: any) => !file.isOutput)
                ?.map((file: any, index) => (
                  <div key={index}>
                    <FileItem
                      fileFields={props.fileFields?.filter(
                        (field: any) =>
                          field.ioType === "input" && !field.isHidden
                      )}
                      file={file}
                      canFileBeRemoved={canFileBeRemoved}
                      shouldBeDisabled={shouldBeDisabled}
                      isChecked={isChecked}
                      updateFileLinkedField={props.updateFileLinkedField}
                      deleteFile={props.deleteFile}
                    />
                  </div>
                ))}
            </div>
          )}

          {props.detailed &&
            props.fileFields?.filter(
              (field: any) => field.ioType === "output" && !field.isHidden
            ).length > 0 && (
              <>
                <p className="filelink-category-io-title">
                  Documenti ricevuti da Cosmilano
                </p>
                {props.files
                  ?.filter((file: any) => file.imageUrl)
                  ?.filter((file: any) => file.isOutput)
                  ?.map((file: any, index) => (
                    <div key={index}>
                      <FileItem
                        fileFields={props.fileFields?.filter(
                          (field: any) =>
                            field.ioType === "output" && !field.isHidden
                        )}
                        file={file}
                        canFileBeRemoved={canFileBeRemoved}
                        shouldBeDisabled={shouldBeDisabled}
                        isChecked={isChecked}
                        updateFileLinkedField={props.updateFileLinkedField}
                        deleteFile={props.deleteFile}
                      />
                    </div>
                  ))}
              </>
            )}
        </div>

        <div className="attesa-files-buttons attesa-button-font">
          <button className="attesa-button-cancel" onClick={props.dismiss}>
            Chiudi
          </button>
          <button className="attesa-button-save" onClick={closeIt}>
            ACCETTA
          </button>
        </div>
      </div>
    </IonModal>
  );
};

function FileItem(props: any) {
  return (
    <>
      <div className="attesa-flex">
        <div className="attesa-item-preview">
          <a href={props.file.preview} target="_blank" rel="noreferrer">
            <img
              src={
                props.file.preview && !props.file.preview.includes(".pdf")
                  ? props.file.preview
                  : PDFLogo
              }
              className="attesa-image"
            />
          </a>
        </div>
        <div className="attesa-full">
          <div className="attesa-item-title-bar">
            <div className="mukta-normal-500-16 attesa-file-name">
              {props.file.name ?? getNameFromUrl(props.file.imageUrl ?? "")}
            </div>
            {props.canFileBeRemoved(props.file) && (
              <div
                onClick={() => props.deleteFile(props.file.path)}
                className="pointer"
              >
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1429 1.12501H15.4286C15.7442 1.12501 16 1.37685 16 1.68751V2.81251C16 3.12317 15.7442 3.37501 15.4286 3.37501H0.571429C0.255837 3.37501 0 3.12317 0 2.81251V1.68751C0 1.37685 0.255837 1.12501 0.571429 1.12501H4.85714L5.19286 0.46759C5.33552 0.18041 5.6324 -0.00121656 5.95714 1.23319e-05H10.0393C10.3646 -0.000217374 10.6621 0.180906 10.8071 0.46759L11.1429 1.12501ZM1.14286 16.3125C1.14286 17.2445 1.91037 18 2.85714 18H13.1429C14.0896 18 14.8571 17.2445 14.8571 16.3125V4.50001H1.14286V16.3125ZM10.8571 7.31251C10.8571 7.00185 11.113 6.75001 11.4286 6.75001C11.7442 6.75001 12 7.00185 12 7.31251V15.1875C12 15.4982 11.7442 15.75 11.4286 15.75C11.113 15.75 10.8571 15.4982 10.8571 15.1875V7.31251ZM8 6.75001C7.68441 6.75001 7.42857 7.00185 7.42857 7.31251V15.1875C7.42857 15.4982 7.68441 15.75 8 15.75C8.31559 15.75 8.57143 15.4982 8.57143 15.1875V7.31251C8.57143 7.00185 8.31559 6.75001 8 6.75001ZM4 7.31251C4 7.00185 4.25584 6.75001 4.57143 6.75001C4.88702 6.75001 5.14286 7.00185 5.14286 7.31251V15.1875C5.14286 15.4982 4.88702 15.75 4.57143 15.75C4.25584 15.75 4 15.4982 4 15.1875V7.31251Z"
                    fill="black"
                  />
                </svg>
              </div>
            )}
          </div>
          <div className="mukta-normal-700-16"> Associa: </div>
          <div className="attesa-flex-wrap">
            {props.fileFields.map((field: any, index: any) => (
              <div key={index} className="attesa-file-checkboxs">
                <div className="attesa-file-list-checkbox">
                  <IonCheckbox
                    color="primary"
                    slot="start"
                    disabled={
                      field.disabled ||
                      props.shouldBeDisabled(field.formName, props.file.path)
                    }
                    checked={props.isChecked(field.formName, props.file.path)}
                    onIonChange={(e: any) =>
                      props.updateFileLinkedField(
                        props.file.path,
                        field.formName,
                        e.detail.checked
                      )
                    }
                  />
                </div>
                <span className="mukta-normal-500-14" key={index}>
                  <span>{(index + 1).toString().padStart(2, "0")} -</span>
                  <span> {field.name}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="attesa-file-divider" />
    </>
  );
}

export default AttesaFileLink;
